export default __webpack_public_path__ + "static/media/Mute.bf5d70ea.svg";